import { FaScaleUnbalancedFlip, FaHandHoldingDollar } from 'react-icons/fa6';
import { TbApi, TbFile } from 'react-icons/tb';
import { NavLink } from 'react-router-dom';

import { Menu, MenuItem, menuClasses, MenuItemStyles } from '@core/ProSidebar';

import { useLayout } from '@/context/AppAuthContext';

import { hexToRgba } from '@/layouts/AppLayout/utils/helpers';
import { themes } from '@/layouts/AppLayout/utils/constants';
import { INITIAL_PATH } from '@/constants';

const MENU_ITEMS = [
  {
    id: 'key-api-clients',
    name: 'Clients Api',
    path: `${INITIAL_PATH}/api-clients`,
    icon: TbApi,
    iconSize: 30,
  },
  {
    id: 'key-get-rate',
    name: 'Get Rate',
    path: `${INITIAL_PATH}/get-rate`,
    icon: FaScaleUnbalancedFlip,
    iconSize: 20,
  },
  {
    id: 'key-accessorial-charges',
    name: 'Accessorial Charges',
    path: `${INITIAL_PATH}/accessorial-charges`,
    icon: FaHandHoldingDollar,
    iconSize: 19,
  },
  {
    id: 'key-freight-bill-details',
    name: 'Freight Bill Details',
    path: `${INITIAL_PATH}/freight-bill-details/764779`,
    icon: TbFile,
    iconSize: 20,
  },
];

const SidebarMenu = () => {
  const { collapsed, hasImage, theme } = useLayout();

  const menuItemStyles: MenuItemStyles = {
    root: {
      fontSize: '13px',
      fontWeight: 400,
    },
    icon: {
      color: themes[theme].menu.icon,
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
    },
    SubMenuExpandIcon: {
      color: '#b6b7b9',
    },
    subMenuContent: ({ level }) => ({
      backgroundColor:
        level === 0
          ? hexToRgba(themes[theme].menu.menuContent, hasImage && !collapsed ? 0.4 : 1)
          : 'transparent',
    }),
    button: {
      marginInline: '6px',
      borderRadius: '0.2rem',
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      '&:hover': {
        backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, hasImage ? 0.8 : 1),
        color: themes[theme].menu.hover.color,
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };

  return (
    <div className="flex-1 pt-3">
      <Menu menuItemStyles={menuItemStyles}>
        {MENU_ITEMS.map((item) => (
          <MenuItem
            key={item.id}
            style={{ justifyContent: 'center' }}
            component={<NavLink to={item.path}></NavLink>}
            icon={<item.icon className="me-1 text-white" size={item.iconSize} />}
            className="capitalize"
          >
            {!collapsed && item.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SidebarMenu;
